var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnProfilo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,256c-52.9,0-99.5-49.7-104-110.8c-2.3-31,7.3-59.7,27-80.8C198.4,43.5,225.8,32,256,32c30,0,57.3,11.6,76.8,32.6 c19.8,21.3,29.4,49.9,27.1,80.6c0,0,0,0,0,0C355.4,206.3,308.8,256,256,256z M256,64c-21.2,0-40.3,7.9-53.6,22.2 c-13.5,14.5-20.1,34.7-18.5,56.7c3.2,44,36.2,81.2,72,81.2c35.8,0,68.8-37.2,72-81.2v0c1.6-21.7-5-41.8-18.7-56.5 C296,71.9,277,64,256,64z M344,144L344,144L344,144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,480H80c-9.6,0-18.2-4-24.2-11.1c-6.5-7.8-9.1-18.4-7.2-29.1c8.4-46.8,34.8-86.2,76.2-113.7 c36.8-24.5,83.4-38,131.2-38c47.8,0,94.4,13.5,131.2,38c41.4,27.6,67.8,66.9,76.2,113.7c1.9,10.7-0.7,21.3-7.2,29.1 C450.2,476,441.6,480,432,480z M80.2,448h351.6c0.2-0.5,0.3-1.3,0.1-2.6c-6.9-38.1-28.5-70.1-62.5-92.8 c-31.6-21-71.9-32.6-113.4-32.6c-41.6,0-81.9,11.6-113.4,32.6c-34,22.7-55.6,54.7-62.5,92.8C79.9,446.7,80,447.5,80.2,448z  M79.8,448L79.8,448L79.8,448z M432.2,448L432.2,448L432.2,448z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnProfilo);
export default __webpack_public_path__ + "static/media/icn_profilo.4c3108ca.svg";
export { ForwardRef as ReactComponent };